const _excluded = ["rowId", "disableRowDnD", "disableRowSelection"];function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import uniqueID from "../../../../../shared/uniqueID";



import { t } from "../../../../I18N";


const commonPropertyTitle = {
  label: 'Title',
  name: 'title',
  type: 'text',
  isCommonProperty: true
};

const commonPropertyDateAdded = {
  label: 'Date added',
  name: 'creationDate',
  type: 'date',
  isCommonProperty: true
};

const commonPropertyDateModified = {
  label: 'Date modified',
  name: 'editDate',
  type: 'date',
  isCommonProperty: true
};

const properties = [];

// @ts-ignore
const emptyTemplate = {
  name: '',
  color: '#C03B22',
  entityViewPage: '',
  properties,
  commonProperties: [commonPropertyTitle, commonPropertyDateAdded, commonPropertyDateModified]
};

const translationsKeys = {
  date: 'property date',
  daterange: 'property daterange',
  generatedid: 'property generatedid',
  geolocation: 'property geolocation',
  image: 'property image',
  link: 'property link',
  markdown: 'property markdown',
  media: 'property media',
  multidate: 'property multidate',
  multidaterange: 'property multidaterange',
  multiselect: 'property multiselect',
  numeric: 'property numeric',
  preview: 'property preview',
  relationship: 'property relationship',
  select: 'property select',
  text: 'property text',
  nested: 'property nested'
};

const confirmationMessages = {
  templateConflict: {
    title: 'Template conflict',
    key: 'Mapping conflict error',
    text: `A reindex of your collection is necessary. The reason may vary
     -- from certain changes made to a template's property to new fields
     that need to be populated across entities.
     This process will not negatively affect the data in your collection.
     It can last a few minutes and some parts of your collection might take
     some time to reappear in the Library, but this is temporary. Do you want to continue?`
  },
  largeNumberOfEntities: {
    title: 'Lengthy reindex process',
    key: 'Template with a long number of entities',
    text: `The template has changed and the associated entities will be re-indexed,
    this process may take several minutes, do you want to continue?`
  }
};

const processDefaultProperties = (props) =>
props.map((prop) => _objectSpread(_objectSpread({},
prop), {}, {
  rowId: uniqueID(),
  disableRowDnD: true,
  disableRowSelection: t('System', 'This property can not be deleted', null, false) })
);

const processProperties = (props) =>
props.map((prop) => _objectSpread(_objectSpread({},
prop), {}, {
  rowId: uniqueID() })
);

const cleanProperty = (prop) => {
  const { rowId, disableRowDnD, disableRowSelection } = prop,rest = _objectWithoutProperties(prop, _excluded);
  return rest;
};

export {
  processDefaultProperties,
  processProperties,
  cleanProperty,
  emptyTemplate,
  translationsKeys,
  confirmationMessages };